import { t } from '../context/LocaleContext';
import React from 'react';
import { Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  backPath?: string;
  extra?: React.ReactNode;
  onBack?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, backPath, extra, onBack }) => {
  const navigate = useNavigate();
  useLocale();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    // 返回 = 返回上一步（回到真实来源页）。
    // 原实现是 backPath 优先、`navigate(-1)` 最后，导致同一个详情页被多个入口进入时，
    // 返回永远跳到那个固定页 —— 例如「订单详情」可被订单列表 / 操作日志 / 回收站 /
    // 门店详情的订单列表 / 团队订单管理 等 6+ 处进入，只有从订单列表进时才碰巧正确。
    // react-router v6 在 history.state 里维护 idx（当前在历史栈中的位置），
    // idx > 0 即表示确实有上一步可退。
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
      return;
    }
    // 直接输网址 / 新开标签进入时没有上一步，用 backPath 兜底；
    // 连 backPath 都没配就回首页，避免 navigate(-1) 把用户带出应用。
    navigate(backPath || '/');
  };

  return (
    <div className="jds-page-header">
      <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 'clamp(8px, 1vw, 16px)'
      }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 1vw, 14px)' }}>
          {(backPath || onBack) &&
          <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={handleBack}
          style={{ paddingLeft: 0, marginTop: 2, fontSize: 'var(--font-sm)' }}
          size="middle">

              {t('返回')}
            </Button>}

          <div>
            <h1 className="jds-page-title">{title}</h1>
            {subtitle && <p className="jds-page-desc">{subtitle}</p>}
          </div>
        </div>
        {extra &&
        <div className="jds-page-actions">
            <Space size={12} wrap>
              {extra}
            </Space>
          </div>}

      </div>
    </div>);

};

export default PageHeader;